import axios from 'axios';
import { API_ENDPOINTS } from '../api-urls';

// Get all active products
export const getAllProducts = async (queryString = "") => {
  try {
    const url = `${API_ENDPOINTS.getAllProducts}${queryString}`;
    console.log("Fetching products with URL:", url);
    const response = await axios.get(url);
    console.log("Raw products response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching all active products with filters:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data, // Log the response body
    });
    throw error;
  }
};
export const getProductById = async (productId) => {
  try {
    const response = await axios.get(`${API_ENDPOINTS.getProductById}${productId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching product with ID ${productId}:`, error);
    throw error;
  }
};


// Get products for a specific category
export const getProductsByCategory = async (categoryId) => {
  try {
    const response = await axios.get(`${API_ENDPOINTS.getAllProductsInCategory}${categoryId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching products for category ${categoryId}:`, error);
    throw error;
  }
};

export const getAllRelatedProductsById = async (productId) => {
  try {
    const response = await axios.get(`${API_ENDPOINTS.getAllRelatedProducts}${productId}`);
    return response.data?.data || [];  // Extracts only the `data` array
  } catch (error) {
    console.error(`Error fetching related products for ID ${productId}:`, error);
    throw error;
  }
};

export const getAllFilters = async () => {
  try {
    const response = await axios.get(API_ENDPOINTS.getAllFilters);
    console.log("Raw API response from getAllFilters:", response.data); // Log raw response
    return response.data; // Ensure this matches { sizes: [], colors: [], min_price: 0, max_price: 0 }
  } catch (error) {
    console.error("Error fetching filter options:", {
      message: error.message,
      code: error.code,
      response: error.response ? {
        status: error.response.status,
        data: error.response.data,
      } : "No response available",
    });
    return { sizes: [], colors: [], min_price: 0, max_price: 0 }; // Return default instead of throwing
  }
};

